import { ChangeDetectionStrategy, Component, computed, Input, Signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Menu } from './models/menu';
import { MenuService } from './services/menu.service';
import { PageService } from '../../services/page/page.service';
import { PageKey } from '../../services/page/models/page.key';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    imports: [
        RouterLink,
        NgTemplateOutlet,
        NgClass,
    ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuComponent {

  constructor(
    private readonly menuService: MenuService,
    private readonly pageService: PageService,
  ) {}

  @Input({ required: true })
  public menus: Menu[] = [];

  public activatedIndex = computed((): number => {
    const currentPageKey = this.pageService.page();

    if (!currentPageKey)
      return -1;

    return this.menus.findIndex(menu => {
      return (
        menu.key === currentPageKey ||
        menu.submenus?.find(submenu => submenu.key === currentPageKey)
      );
    });
  });

  public shortMode: Signal<boolean> = this.menuService.short;

  public pageKey: Signal<PageKey | null> = this.pageService.page;

  public setShortMode(): void {
    this.menuService.short = true;
  }

  public toggleMenu(index: number): void {
    const menu = this.menus[index];

    if (!menu || !menu.submenus?.length)
      return;

    this.menus[index].opened = !this.menus[index].opened
  }

}
